import { render, staticRenderFns } from "./DailyHealthReportAllBUV2.vue?vue&type=template&id=2bcd7806&scoped=true&"
import script from "./DailyHealthReportAllBUV2.vue?vue&type=script&lang=js&"
export * from "./DailyHealthReportAllBUV2.vue?vue&type=script&lang=js&"
import style0 from "./DailyHealthReport.scss?vue&type=style&index=0&id=2bcd7806&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd7806",
  null
  
)

export default component.exports